import { useState } from "react";

const memoryState : any = {};

export default function useMemoryState(key : string, initialState : any) {
  const [state, setState] = useState(() => {
    const hasMemoryValue = Object.prototype.hasOwnProperty.call(memoryState, key);
    if (hasMemoryValue) {
      return memoryState[key]
    } else {
      return typeof initialState === 'function' ? initialState() : initialState;
    }
  });

  function onChange(nextState : any) {
    memoryState[key] = nextState;
    setState(nextState);
  }

  return [state, onChange];
}